export const displayError = async (container: HTMLElement, message: string) => {
  const error = document.createElement('div')
  error.setAttribute('id', 'error')
  error.setAttribute('data-error-type', 'xund-authorization-error')

  /*eslint-disable-next-line*/
  console.warn('Please check your XUND authentication settings...')

  error.innerHTML = `
  <div id="error-container">
    <h1 id="xund-authorization-error-message"></h1>
    <p>
      <small>Please retry again later.</small>
    </p>
  </div>
  `

  const errorMessageElement = error.querySelector('#xund-authorization-error-message')
  if (errorMessageElement) {
    errorMessageElement.textContent = message
  }
  if (container.parentNode) {
    container.parentNode.insertBefore(error, container)
  }
}
